module.exports = __webpack_public_path__ + "img/電気回路_4_4_5.b152269b.png";